/**
 * ThryvApi on legacy pages.
 *
 * A THIN ENTRY OVER THE NATIVE MODULE, not a copy of it. resources/js/app/thryv-api is plain ES
 * modules with no Alpine, no Vite and no import.meta — its only import outside its own folder is
 * app/helpers/loader.js — so legacy's rollup can bundle the same source the native theme uses.
 *
 * WHY THIS EXISTS. Native assets are gated behind RenderMode::isNativeRequest(), so a legacy
 * page-builder page gets no window.ThryvApi and no window.OneMind. The alternative was a second
 * implementation under legacy/src2, which is exactly what src2/1mind already is — and its native
 * twin says so: "DEPLOYMENT IDS AND THE FIELD MAP EXIST IN BOTH PLACES. When 1Mind changes an id,
 * change it here AND in legacy/src2/1mind/Config.js." One source removes that standing trap.
 *
 * Publishes window.ThryvApi (and window.OneMind, via OneMind.boot()). Loading this bundle on a
 * page that already has the native app.js is harmless — both boot the same objects.
 */
import { ThryvApi } from "../../../resources/js/app/thryv-api";

ThryvApi.boot();

export default ThryvApi;
